import { Builder } from '@builder.io/react';

import AfterScale from './index';

Builder.registerComponent(AfterScale, {
  name: 'After Scale',
  inputs: [
    {
      name: 'before',
      type: 'list',
      defaultValue: [
        {
          text: 'item'
        },
        { text: 'item' }
      ],
      subFields: [
        {
          name: 'text',
          type: 'string'
        }
      ]
    },
    {
      name: 'after',
      type: 'list',
      defaultValue: [
        {
          text: 'item'
        },
        { text: 'item' }
      ],
      subFields: [
        {
          name: 'text',
          type: 'string'
        }
      ]
    }
  ]
});
